import { createAction } from '@reduxjs/toolkit';

export const authLogoutAction = createAction('authLogoutAction');
